// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1a7913fc","667":"009e4754"}[chunkId] + ".chunk.js";
};